module.exports = __webpack_public_path__ + "img/trailer-icon2.9ffa5aa6.png";